// ComfyHug — scripts propios (vanilla JS, sin librerías externas)

function initReveal() {
  const els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('mt-visible'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  els.forEach((el) => observer.observe(el));
}

function initFaq() {
  const items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;

  items.forEach((item) => {
    const btn = item.querySelector('.mt-faq-item__pregunta');
    const respuesta = item.querySelector('.mt-faq-item__respuesta');
    if (!btn || !respuesta) return;

    btn.addEventListener('click', () => {
      const isOpen = item.classList.contains('is-open');

      items.forEach((other) => {
        other.classList.remove('is-open');
        const otherRespuesta = other.querySelector('.mt-faq-item__respuesta');
        if (otherRespuesta) otherRespuesta.style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('is-open');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}

// Galería del producto: un solo escuchador en el documento, así sigue funcionando
// aunque Shopify vuelva a pintar la sección (editor de temas, cambios de variante...)
function mtGaleriaCambiar(wrap, thumb) {
  const principal = wrap.querySelector('[data-mt-galeria-principal]');
  const video = wrap.querySelector('[data-mt-galeria-video]');
  const videoThumb = wrap.querySelector('[data-mt-galeria-video-thumb]');
  const miniaturas = wrap.querySelectorAll('[data-mt-galeria-thumb]');

  if (thumb.hasAttribute('data-mt-galeria-video-thumb')) {
    if (!video) return;
    video.hidden = false;
    video.style.display = '';
    video.play().catch(() => {});
    miniaturas.forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
    return;
  }

  const src = thumb.getAttribute('data-full');
  if (!src || !principal) return;
  if (video) {
    video.pause();
    video.hidden = true;
    video.style.display = 'none';
  }
  if (videoThumb) videoThumb.classList.remove('is-active');
  miniaturas.forEach((t) => t.classList.remove('is-active'));
  thumb.classList.add('is-active');

  principal.style.opacity = 0;
  window.setTimeout(() => {
    // srcset manda sobre src: si no se quita, la foto grande nunca cambia
    principal.removeAttribute('srcset');
    principal.removeAttribute('sizes');
    principal.src = src;
    principal.alt = thumb.getAttribute('data-alt') || '';
    principal.style.opacity = 1;
  }, 150);
}

function initGaleriaProducto() {
  document.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-mt-galeria-thumb], [data-mt-galeria-video-thumb]');
    if (!thumb) return;
    const wrap = thumb.closest('[data-mt-galeria]');
    if (!wrap) return;
    e.preventDefault();
    mtGaleriaCambiar(wrap, thumb);
  });

  const arrancarVideos = () => {
    document.querySelectorAll('[data-mt-galeria-video]').forEach((video) => {
      if (video.hidden) return;
      video.muted = true;
      video.play().catch(() => {});
    });
  };
  arrancarVideos();
  document.addEventListener('shopify:section:load', arrancarVideos);
}

function initVariantesProducto() {
  const form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;

  const variantsJson = form.querySelector('[data-mt-variants-json]');
  if (!variantsJson) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsJson.textContent);
  } catch (e) {
    return;
  }

  const idInput = form.querySelector('input[name="id"]');
  const pillGroups = form.querySelectorAll('[data-mt-option-index]');
  const precioActual = document.querySelector('[data-mt-precio-actual]');
  const precioTachado = document.querySelector('[data-mt-precio-tachado]');
  const submitBtn = form.querySelector('[data-mt-submit]');
  const submitText = submitBtn ? submitBtn.querySelector('[data-mt-submit-text]') : null;

  function moneyFormat(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';
    return '$' + (cents / 100).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + cur;
  }

  function selectedOptions() {
    const options = [];
    pillGroups.forEach((group) => {
      const active = group.querySelector('.is-active');
      options.push(active ? active.getAttribute('data-value') : null);
    });
    return options;
  }

  function findVariant() {
    const options = selectedOptions();
    return variants.find((v) => v.options.every((opt, i) => opt === options[i]));
  }

  function updateUI() {
    const variant = findVariant();
    if (!variant) {
      if (submitBtn) submitBtn.disabled = true;
      if (submitText) submitText.textContent = submitText.getAttribute('data-unavailable-text') || submitText.textContent;
      return;
    }

    idInput.value = variant.id;

    // Foto principal = foto del estilo elegido (si la variante tiene una asignada)
    if (variant.featured_image) {
      const galeria = document.querySelector('[data-mt-galeria]');
      const thumb = galeria && galeria.querySelector('[data-mt-galeria-thumb][data-image-id="' + variant.featured_image.id + '"]');
      if (thumb && !thumb.classList.contains('is-active')) {
        mtGaleriaCambiar(galeria, thumb);
        // Solo desplaza la tira de miniaturas en horizontal, nunca la página
        const tira = thumb.parentElement;
        if (tira && tira.scrollWidth > tira.clientWidth) {
          const desde = thumb.getBoundingClientRect().left - tira.getBoundingClientRect().left;
          tira.scrollTo({ left: tira.scrollLeft + desde - (tira.clientWidth - thumb.clientWidth) / 2, behavior: 'smooth' });
        }
      }
    }

    if (precioActual) precioActual.textContent = moneyFormat(variant.price);
    if (precioTachado) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        precioTachado.textContent = moneyFormat(variant.compare_at_price);
        precioTachado.hidden = false;
      } else {
        precioTachado.hidden = true;
      }
    }

    if (submitBtn) {
      if (variant.available) {
        submitBtn.disabled = false;
        if (submitText) submitText.textContent = submitText.getAttribute('data-add-text') || submitText.textContent;
      } else {
        submitBtn.disabled = true;
        if (submitText) submitText.textContent = submitText.getAttribute('data-soldout-text') || submitText.textContent;
      }
    }

    pillGroups.forEach((group, index) => {
      group.querySelectorAll('[data-value]').forEach((pill) => {
        const testOptions = selectedOptions();
        testOptions[index] = pill.getAttribute('data-value');
        const exists = variants.some((v) => v.options.every((opt, i) => opt === testOptions[i]));
        pill.disabled = !exists;
      });
    });

    document.dispatchEvent(new CustomEvent('mt:variant-price-changed', { detail: { priceCents: variant.price } }));
  }

  pillGroups.forEach((group) => {
    group.querySelectorAll('[data-value]').forEach((pill) => {
      pill.addEventListener('click', () => {
        if (pill.disabled) return;
        group.querySelectorAll('[data-value]').forEach((p) => p.classList.remove('is-active'));
        pill.classList.add('is-active');
        updateUI();
      });
    });
  });

  updateUI();
}

function initNivelesProducto() {
  const wrap = document.querySelector('[data-mt-tiers]');
  if (!wrap) return;

  const tiers = Array.from(wrap.querySelectorAll('[data-mt-tier]'));
  const cantidadInput = document.querySelector('[data-mt-cantidad] input');
  let unitPrice = parseInt(wrap.getAttribute('data-unit-price-cents'), 10) / 100;

  function moneyFormat(amount) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'MXN';
    return '$' + amount.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + cur;
  }

  function renderTiers() {
    tiers.forEach((tier) => {
      const qty = parseInt(tier.getAttribute('data-qty'), 10);
      const discount = parseFloat(tier.getAttribute('data-discount')) || 0;
      const total = unitPrice * qty * (1 - discount / 100);
      const priceEl = tier.querySelector('[data-mt-tier-price]');
      if (priceEl && unitPrice) priceEl.textContent = moneyFormat(total);
    });
  }

  renderTiers();

  document.addEventListener('mt:variant-price-changed', (e) => {
    if (!e.detail || typeof e.detail.priceCents !== 'number') return;
    unitPrice = e.detail.priceCents / 100;
    wrap.setAttribute('data-unit-price-cents', String(e.detail.priceCents));
    renderTiers();
  });

  tiers.forEach((tier) => {
    const qty = parseInt(tier.getAttribute('data-qty'), 10);
    tier.addEventListener('click', () => {
      tiers.forEach((t) => t.classList.remove('is-active'));
      tier.classList.add('is-active');
      if (cantidadInput) cantidadInput.value = qty;
    });
  });

  if (cantidadInput) {
    cantidadInput.addEventListener('input', () => {
      const val = parseInt(cantidadInput.value, 10);
      tiers.forEach((t) => {
        t.classList.toggle('is-active', parseInt(t.getAttribute('data-qty'), 10) === val);
      });
    });
  }
}

function initCantidadProducto() {
  const wrap = document.querySelector('[data-mt-cantidad]');
  if (!wrap) return;
  const input = wrap.querySelector('input');
  const menos = wrap.querySelector('[data-mt-menos]');
  const mas = wrap.querySelector('[data-mt-mas]');
  if (!input || !menos || !mas) return;

  menos.addEventListener('click', () => {
    input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
  });
  mas.addEventListener('click', () => {
    input.value = parseInt(input.value || '1', 10) + 1;
  });
}

function initLazyVideo() {
  const videos = document.querySelectorAll('[data-mt-lazy-video]');
  if (!videos.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const video = entry.target;
        const source = video.querySelector('source[data-src]');
        if (source) {
          source.src = source.getAttribute('data-src');
          source.removeAttribute('data-src');
          video.load();
        }
        video.play().catch(() => {});
        observer.unobserve(video);
      });
    },
    { rootMargin: '200px 0px' }
  );

  videos.forEach((video) => observer.observe(video));
}

function initCarousel() {
  const carousels = document.querySelectorAll('[data-mt-carousel]');
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const viewport = carousel.querySelector('[data-mt-carousel-viewport]');
    const items = Array.from(carousel.querySelectorAll('[data-mt-carousel-item]'));
    const prevBtn = carousel.querySelector('[data-mt-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-mt-carousel-next]');
    const dotsWrap = carousel.parentElement.querySelector('[data-mt-carousel-dots]');
    if (!viewport || !items.length) return;

    function itemPosition(item) {
      return item.getBoundingClientRect().left - viewport.getBoundingClientRect().left + viewport.scrollLeft;
    }

    const dots = items.map((item, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mt-resenas__dot';
      dot.setAttribute('aria-label', 'Ir a la diapositiva ' + (i + 1));
      dot.addEventListener('click', () => goTo(i));
      if (dotsWrap) dotsWrap.appendChild(dot);
      return dot;
    });

    function currentIndex() {
      const scrollLeft = viewport.scrollLeft;
      let closest = 0;
      let closestDist = Infinity;
      items.forEach((item, i) => {
        const dist = Math.abs(itemPosition(item) - scrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function updateUI() {
      const index = currentIndex();
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      if (prevBtn) prevBtn.disabled = viewport.scrollLeft <= 2;
      if (nextBtn) nextBtn.disabled = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 2;
    }

    function goTo(index) {
      const clamped = Math.max(0, Math.min(items.length - 1, index));
      viewport.scrollLeft = itemPosition(items[clamped]);
      updateUI();
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(currentIndex() - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(currentIndex() + 1));

    let scrollTimer;
    viewport.addEventListener('scroll', () => {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(updateUI, 80);
    });

    window.addEventListener('resize', updateUI);
    updateUI();
  });
}

function initCountdown() {
  const bar = document.querySelector('[data-mt-countdown]');
  if (!bar) return;
  const display = bar.querySelector('[data-mt-countdown-display]');
  if (!display) return;

  const end = new Date(bar.getAttribute('data-end')).getTime();
  if (isNaN(end)) return;

  function tick() {
    const now = Date.now();
    const diff = end - now;

    if (diff <= 0) {
      bar.remove();
      window.clearInterval(timer);
      return;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    const pad = (n) => String(n).padStart(2, '0');
    display.textContent =
      (days > 0 ? days + 'd ' : '') + pad(hours) + ':' + pad(minutes) + ':' + pad(seconds);
  }

  tick();
  const timer = window.setInterval(tick, 1000);
}

function initSpin360() {
  const viewers = document.querySelectorAll('[data-mt-spin]');
  if (!viewers.length) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  viewers.forEach((el) => {
    const frames = Array.from(el.querySelectorAll('[data-mt-spin-frame]'));
    if (frames.length < 2) return;

    let current = 0;

    function show(index) {
      const total = frames.length;
      const wrapped = ((index % total) + total) % total;
      frames.forEach((f, i) => f.classList.toggle('is-active', i === wrapped));
      current = wrapped;
    }

    show(0);
    if (!reduceMotion) {
      setInterval(() => show(current + 1), 1000);
    }
  });
}

function initCheckoutDirecto() {
  function resetBtn(btn) {
    btn.classList.remove('loading');
    btn.removeAttribute('aria-disabled');
    const spinner = btn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.add('hidden');
  }

  document.addEventListener(
    'submit',
    async function (e) {
      const form = e.target;
      if (!form || !form.matches || !form.matches('[data-mt-producto-form]')) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      const btn = form.querySelector('[data-mt-submit]');
      if (!btn || btn.disabled || btn.classList.contains('loading')) return;

      const wrap = form.closest('product-form');
      const errBox = wrap && wrap.querySelector('.product-form__error-message-wrapper');
      const errMsg = wrap && wrap.querySelector('.product-form__error-message');
      if (errBox) errBox.hidden = true;

      btn.classList.add('loading');
      btn.setAttribute('aria-disabled', 'true');
      const spinner = btn.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });
        const data = await res.json();
        if (!res.ok || data.status) {
          throw new Error(data.description || data.message || 'No pudimos agregar este producto a tu carrito.');
        }
        window.location.href = root + 'checkout';
      } catch (err) {
        resetBtn(btn);
        if (errBox && errMsg) {
          errMsg.textContent = err.message;
          errBox.hidden = false;
        }
      }
    },
    true
  );

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-mt-submit]').forEach(resetBtn);
  });
}

function initAll() {
  if (window.__mtInitDone) return;
  window.__mtInitDone = true;
  initCheckoutDirecto();
  initReveal();
  initFaq();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
  initNivelesProducto();
  initCountdown();
  initSpin360();
  initCarousel();
  initLazyVideo();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}
